/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AsCodeTagReferenceDto = {
    id?: string;
    kind?: AsCodeTagReferenceDto.kind;
    name?: string;
};

export namespace AsCodeTagReferenceDto {

    export enum kind {
        TAG = 'Tag',
        CLASSIFICATION = 'Classification',
    }


}
